var _defs, _path, _polygon, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ARTWORK",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke:#fff;stroke-linejoin:round;stroke-width:0.75px;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,12a9,9,0,0,1-6.2,8.55A8.93,8.93,0,0,1,12,21a8.84,8.84,0,0,1-2.83-.46A9,9,0,0,1,3,12a8.66,8.66,0,0,1,.39-2.6,9,9,0,0,1,5.84-6A8.83,8.83,0,0,1,12,3a9,9,0,0,1,8.61,6.4A8.66,8.66,0,0,1,21,12Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.49 9.4 10.48 9.4 8.97 12.01 10.48 14.62 13.49 14.62 15 12.01 13.49 9.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6,12l-1.5,2.61H3.39A9.08,9.08,0,0,1,3,12a8.66,8.66,0,0,1,.39-2.6H4.51Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21,12a9.08,9.08,0,0,1-.39,2.62H19.49L18,12l1.5-2.61h1.12A8.66,8.66,0,0,1,21,12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.8,20.55A8.93,8.93,0,0,1,12,21a8.84,8.84,0,0,1-2.83-.46l1.31-2.26h3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.75,3.43,13.49,5.61h-3L9.23,3.44A8.83,8.83,0,0,1,12,3,8.94,8.94,0,0,1,14.75,3.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/ball.db4368190f26c01e59641ed1468b6ce7.svg";
export { ForwardRef as ReactComponent };